
var inlineNews = {
    init : function(id){
      
		$slider = $( id+ ' .news-grid');
	        $slider.owlCarousel({
        	  responsiveClass:true,
              nav:false,
        	  lazyLoad: true,
        	  margin:30,
        	  responsive:{
			        0:{
			            items:1,
			            margin: 15,
			            loop: ($( id+ ' .news-grid .inline-item').length > 1) ?true:false,
			            pullDrag: ($( id+ ' .news-grid .inline-item').length > 1) ?true:false,
			        	mouseDrag: ($( id+ ' .news-grid .inline-item').length > 1) ?true:false,
			        	touchDrag: ($( id+ ' .news-grid .inline-item').length > 1) ?true:false,
			        },
			         
			        576:{
			            items:2,
			            margin: 15,
			            loop: ($( id+ ' .news-grid .inline-item').length > 2) ?true:false,
			            pullDrag: ($( id+ ' .news-grid .inline-item').length > 2) ?true:false,
    	  				mouseDrag: ($( id+ ' .news-grid .inline-item').length > 2) ?true:false,
        	  			touchDrag: ($( id+ ' .news-grid .inline-item').length > 2) ?true:false,
			        },

			        992:{
			            items:2,
			            loop: ($( id+ ' .news-grid .inline-item').length > 2) ?true:false,
			            pullDrag: ($( id+ ' .news-grid .inline-item').length > 2) ?true:false,
    	  				mouseDrag: ($( id+ ' .news-grid .inline-item').length > 2) ?true:false,
        	  			touchDrag: ($( id+ ' .news-grid .inline-item').length >2) ?true:false,
			        },

			        1400:{
			            items:3,
			            loop: ($( id+ ' .news-grid .inline-item').length > 3) ?true:false,
			        	pullDrag: ($( id+ ' .news-grid .inline-item').length > 3) ?true:false,
			        	mouseDrag: ($( id+ ' .news-grid .inline-item').length > 3) ?true:false,
			        	touchDrag: ($( id+ ' .news-grid .inline-item').length > 3) ?true:false,
			        }
			    }
        });

   
    }
}

